import { ONGLET_EMPLOYEUR, ONGLET_PRESTATION } from '../shared'

export const OngletsOutilFpe = [ONGLET_EMPLOYEUR, ONGLET_PRESTATION] as const
export type OngletsOutilFpe = (typeof OngletsOutilFpe)[number]

export const OngletsOutilFpeFLibellés: Record<OngletsOutilFpe, string> = {
  Employeur: 'Employeur',
  Prestation: 'Prestation',
}
